export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP///+Xl5f8AAJmZmSH5BAAAAAAALAAAAAASAAwAAAIqTDamwt0BEJjTWYQHtS7LyjHQt4XCqFGAeaoqC7lgGMuwPHO1Cyt+wCoAADs="